import { render, staticRenderFns } from "./ReportTemplateEdit.vue?vue&type=template&id=22ef82e8&"
import script from "./ReportTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./ReportTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports